export default __webpack_public_path__ + "static/media/mednaj.9adfb24a.JPG";